import React, { Component } from "react";

import { connectForm, Form } from "../utils/components/form";
import { InputField } from "../Mitarbeiter/components";

class CustomerAddressForm extends Component {
  labelClass = "col-12 col-sm-4 float-start fs-4 text-gray";
  inputClass = "col-12 col-sm-8";
  state = {
    inputSize: 32
  };

  required = value => value ? undefined : "Bitte tragen Sie einen Wert ein.";
  maxLength = value => (!value || value.length < this.state.inputSize) ? undefined : `Bitte tragen Sie einen Wert mit der Zeichenlänge kleiner als ${this.state.inputSize} ein.`;
  plz = value => (value.length === 5 && String(value).match(/\d{5}/)) ? undefined : "Bitte tragen Sie eine gültige Postleitzahl ein";

  onSubmit = formValues => {
    this.props.onSubmit(formValues);
  };

  render() {
    return (
      <Form onSubmit={this.onSubmit} {...this.props}>
        {props => {
          return (
            <section aria-label="Kundendaten">
              <div className="bootstrap-iso">
                <div className="row">
                  <div className="col-12 col-lg-9">
                    <form
                      onSubmit={props.handleSubmit}
                      className="form-group"
                    >
                      <InputField
                        name="kundenName"
                        label="Name"
                        labelClass={this.labelClass}
                        inputClass={this.inputClass}
                        disabled
                        value={this.props.kundenVorname + " " + this.props.kundenNachname}
                      />
                      <InputField
                        name="name"
                        label="Name Ergänzung"
                        placeholder={"Name Ergänzung"}
                        validate={[this.maxLength]}
                        maxLength={this.state.inputSize}
                        labelClass={this.labelClass}
                        inputClass={this.inputClass}
                      />
                      <InputField
                        name="strasse"
                        label="Straße"
                        placeholder={"Straße und Hausnummer"}
                        validate={[this.required, this.maxLength]}
                        required
                        maxLength={this.state.inputSize}
                        labelClass={this.labelClass}
                        inputClass={this.inputClass}
                      />
                      <InputField
                        name="strasse2"
                        label="Straße 2"
                        placeholder={"Straße und Hausnummer"}
                        validate={[this.maxLength]}
                        maxLength={this.state.inputSize}
                        labelClass={this.labelClass}
                        inputClass={this.inputClass}
                      />
                      <InputField
                        label="PLZ"
                        name="plz"
                        placeholder={"PLZ"}
                        validate={[this.required, this.plz]}
                        required
                        maxLength={5}
                        labelClass={this.labelClass}
                        inputClass={this.inputClass}
                      />
                      <InputField
                        name="ort"
                        label="Ort"
                        placeholder={"Ort"}
                        validate={[this.required, this.maxLength]}
                        maxLength={this.state.inputSize}
                        required
                        labelClass={this.labelClass}
                        inputClass={this.inputClass}
                      />
                      <div className="d-flex justify-content-end">
                        <button
                          className="btn btn-primary col-8 col-lg-3 mb-one"
                          id="kunden_speicher"
                          disabled={props.invalid}
                        >
                          Speichern
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          );
        }}
      </Form>
    );
  }
}

const validate = formValues => {
  const errors = {};
  ["strasse", "plz", "ort"].forEach(key => {
    if (!formValues[key]) {
      errors[key] = "Bitte tragen Sie einen Wert ein.";
    }
  });
  return errors;
};

export default connectForm({
  form: "addressForm",
  validate: validate
})(CustomerAddressForm);
